module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtFive.0ecdc13.png";